import { IconButton } from '@mui/material';
import type { GridApiCommunity } from '@mui/x-data-grid/internals';
import type { PlanOverview } from '@vy/api-definition';
import { getSelectorAttribute, plansOverviewPageSelectors } from '@vy/app-selectors';
import type { MutableRefObject } from 'react';
import React from 'react';
import { PlanMenuModal } from './PlanDotMenuModal';

type PlanDotMenuProps = {
  plan: PlanOverview;
  refetchFunction: () => void;
  apiGridRef: MutableRefObject<GridApiCommunity>;
  rowId: string;
};

export const PlanDotMenu: React.FC<PlanDotMenuProps> = ({ plan, refetchFunction, apiGridRef, rowId }) => {
  return (
    <div
      onClick={(event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      className="flex justify-center"
    >
      <PlanMenuModal refetchFunction={refetchFunction} plan={plan} apiGridRef={apiGridRef} rowId={rowId}>
        <IconButton
          className="aspect-square rounded-full"
          {...getSelectorAttribute(plansOverviewPageSelectors.dotsMenu)}
        >
          <span className="bg-icon text-label mx-2 mb-[3px] inline-block h-1 w-1 rounded-full shadow-[0_7px_0_#ADC2E2,0_-7px_0_#ADC2E2]"></span>
        </IconButton>
      </PlanMenuModal>
    </div>
  );
};
